import {Injectable} from '@angular/core';
import {HttpClient } from '@angular/common/http';
import { cIO_MODBUS_ROOT} from "./modbusData";
import {Observable} from "rxjs";
import {UrlBuilder} from "../url-builder/url.builder";


@Injectable({
  providedIn: 'root'
})
export class ModbusDescriptionDataservice {

  private uiUrl: string = "";
  private url: UrlBuilder;

  constructor(private http: HttpClient) {
    this.url = new UrlBuilder();
  }
  GetData(): Observable<cIO_MODBUS_ROOT> {
    this.uiUrl = this.url.GetModbusDescriptionUrl();
    console.log('FILE: ' + this.uiUrl);
    return this.http.get<cIO_MODBUS_ROOT>(this.uiUrl);
  }


}

